import { getCollection } from '@adornis/baseql/server/collections.js';
import { Exam, type ExamState } from '../../exam.js';
import { resolveTaskTreePath } from '../../utils/task-tree-path.js';

export const updateOpenTaskToolDef = [
  {
    type: 'function',
    function: {
      name: 'update_open_task_content',
      description:
        'Aktualisiert den extrahierten Aufgabentext einer Aufgabe. Für Musterlösung und Bewertungsschema verwende ausschließlich refine_master_solution bzw. refine_grading_scheme oder UI-Edits.',
      parameters: {
        type: 'object',
        properties: {
          target: {
            type: 'string',
            enum: ['task_text'],
            description: 'Welcher Inhalt angepasst werden soll.',
          },
          taskNumber: {
            type: 'string',
            description: 'Optionale Task-Nummer der Zielaufgabe (z.B. "3" oder "2a").',
          },
          taskText: {
            type: 'string',
            description: 'Neuer extrahierter Aufgabentext (Task-Beschreibung).',
          },
        },
        required: ['target'],
      },
    },
  },
];

interface NestedTask {
  taskNumber?: string;
  description?: string;
  subTasks?: NestedTask[];
  masterSolution?: any;
  gradingScheme?: any;
}

export async function handleUpdateOpenTaskContent(exam: Exam, toolCallArgs: any): Promise<object> {
  let toolResultContent = '';
  const examIdToUse = exam._id?.toString();
  const taskNumberToUse = toolCallArgs.taskNumber;
  if (!examIdToUse || !taskNumberToUse) {
    toolResultContent = 'Fehler: ID oder Task fehlt.';
  } else {
    const examCol = await getCollection(Exam);
    const currentExam = await examCol.findOne({ _id: examIdToUse });
    const resolved = resolveTaskTreePath(currentExam?.tasks as NestedTask[] | undefined, taskNumberToUse, 'subTasks');
    if (resolved.status === 'found') {
      resolved.node.description = toolCallArgs.taskText;
      await examCol.updateOne({ _id: examIdToUse }, { $set: { tasks: currentExam?.tasks } });
      toolResultContent = 'SYSTEM INFO: Text aktualisiert.';
    } else if (resolved.status === 'ambiguous') {
      const candidatePaths = resolved.taskNumberPaths.map(p => p.join('.'));
      toolResultContent = `SYSTEM INFO: Aufgabennummer "${taskNumberToUse}" ist mehrdeutig, sie kommt an mehreren Stellen vor (${candidatePaths.join(', ')}). Bitte die vollständige Aufgabennummer angeben (z.B. "${candidatePaths[0]}").`;
    } else {
      toolResultContent = 'Fehler: Task nicht gefunden.';
    }
  }
  return { content: toolResultContent };
}

export function updateOpenTaskAvailability(_examState: ExamState): boolean {
  return true;
}
